import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";
import { CaseService } from "../../cases/_types/case-service";

export class ChatRoom extends Resource {
    public override type = 'chatRooms';

    @prop()
    @required()
    public code!: string;

    @prop()
    @required()
    public title!: string;

    @prop()
    public caseId!: string;

    public case!: Case;

    @prop()
    public caseServiceId!: string;

    public caseService!: CaseService;
}